/* Haven product template: variants, gallery, AJAX add to basket, sticky bar, delivery window, colourway links, scroll reveal. */
(() => {
  if (window.hvHavenLoaded) return;
  window.hvHavenLoaded = true;
  document.documentElement.classList.add('hv-js');

  const formatMoney = (cents, format) => {
    const value = Number(cents) / 100;
    const fmt = (n, dec, thousands, decimal) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : '');
    };
    return (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  };

  class HVProduct {
    constructor(root) {
      this.root = root;
      this.product = JSON.parse(root.querySelector('[data-hv-product-json]').textContent);
      this.config = JSON.parse(root.querySelector('[data-hv-config]').textContent);
      const notes = root.querySelector('[data-hv-colour-notes]');
      this.colourNotes = notes ? JSON.parse(notes.textContent) : {};
      this.form = root.querySelector('[data-hv-form]');
      this.idInput = root.querySelector('[data-hv-variant-id]');
      this.atc = root.querySelector('[data-hv-atc]');
      this.sticky = root.querySelector('[data-hv-sticky]');
      this.variant = this.product.variants.find((v) => String(v.id) === this.idInput.value) || this.product.variants[0];

      root.querySelectorAll('[data-hv-option] input').forEach((input) =>
        input.addEventListener('change', () => this.onOptionChange(input)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.initGallery();
      this.initSticky();
      this.initDelivery();
      this.render();
    }

    money(cents) { return formatMoney(cents, this.config.moneyFormat); }

    findVariant(options) {
      return this.product.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    selectedOptions() {
      return this.product.options.map((_, i) => {
        const checked = this.root.querySelector(`[data-hv-option="${i}"] input:checked`);
        return checked ? checked.value : this.variant.options[i];
      });
    }

    // Used by the colourway cards further down the page.
    selectValue(value) {
      const input = [...this.root.querySelectorAll('[data-hv-option] input')].find((x) => x.value === value);
      if (!input) return false;
      input.checked = true;
      this.onOptionChange(input);
      return true;
    }

    onOptionChange(input) {
      let variant = this.findVariant(this.selectedOptions());
      if (!variant) {
        // Keep the value the shopper just picked; fall back to the first available match.
        const idx = Number(input.closest('[data-hv-option]').dataset.hvOption);
        variant = this.product.variants.find((v) => v.options[idx] === input.value && v.available)
          || this.product.variants.find((v) => v.options[idx] === input.value);
        if (variant) {
          variant.options.forEach((val, i) => {
            const el = [...this.root.querySelectorAll(`[data-hv-option="${i}"] input`)].find((x) => x.value === val);
            if (el) el.checked = true;
          });
        }
      }
      if (!variant) return;
      this.variant = variant;
      this.render();
      this.goToMedia(variant.featured_media && variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    render() {
      const v = this.variant;
      const q = (s) => this.root.querySelector(s);
      const hasCompare = this.config.showCompare && v.compare_at_price && v.compare_at_price > v.price;
      this.idInput.value = v.id;

      q('[data-hv-price-now]').textContent = this.money(v.price);
      const was = q('[data-hv-price-was]');
      was.hidden = !hasCompare;
      if (hasCompare) was.textContent = this.money(v.compare_at_price);
      q('[data-hv-atc-price]').textContent = this.money(v.price);

      this.product.options.forEach((name, i) => {
        const fs = this.root.querySelector(`[data-hv-option="${i}"]`);
        if (!fs) return;
        const label = fs.querySelector('[data-hv-option-value]');
        if (label) label.textContent = v.options[i];
        const note = fs.querySelector('[data-hv-colour-note]');
        if (note) note.textContent = this.colourNotes[v.options[i]] || '';
        fs.querySelectorAll('.hv-choice').forEach((el) => {
          const opts = [...v.options]; opts[i] = el.querySelector('input').value;
          const match = this.findVariant(opts);
          el.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      const stock = q('[data-hv-stock]');
      stock.classList.remove('hv-stock--low', 'hv-stock--out');
      if (!v.available) { stock.textContent = 'Currently sold out'; stock.classList.add('hv-stock--out'); }
      else if (this.config.lowStock[v.id]) { stock.textContent = 'Only a few left in this colour'; stock.classList.add('hv-stock--low'); }
      else stock.textContent = this.config.inStockText;

      this.atc.disabled = !v.available;
      q('[data-hv-atc-text]').textContent = v.available ? this.config.atcText : 'Sold out';

      if (this.sticky) {
        this.sticky.querySelector('[data-hv-sticky-price]').textContent = this.money(v.price);
        this.sticky.querySelector('[data-hv-sticky-variant]').textContent = v.public_title || v.title;
        this.sticky.querySelector('[data-hv-sticky-btn]').disabled = !v.available;
        const img = this.sticky.querySelector('.hv-sticky__img');
        const src = v.featured_image && v.featured_image.src;
        if (img && src) {
          const u = new URL(src, window.location.href);
          u.searchParams.set('width', '140');
          img.removeAttribute('srcset');
          img.src = u.toString();
        }
      }
    }

    /* ---------- Add to basket (uses Shrine's cart drawer/notification when present) ---------- */
    async onSubmit(e) {
      e.preventDefault();
      if (this.atc.disabled) return;
      const errorBox = this.root.querySelector('[data-hv-error]');
      errorBox.classList.remove('is-visible');
      this.atc.classList.add('is-loading');
      this.atc.setAttribute('aria-busy', 'true');

      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const items = [{ id: Number(this.idInput.value), quantity: 1 }];
      this.root.querySelectorAll('[data-hv-addon]:checked').forEach((toggle) => {
        const id = Number(toggle.dataset.hvAddonVariant);
        if (id) items.push({ id, quantity: 1 });
      });

      const payload = { items };
      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        payload.sections = cartUI.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
        if (typeof cartUI.setActiveElement === 'function') cartUI.setActiveElement(document.activeElement);
      }

      try {
        const res = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket.');

        // Shrine/Dawn declare these as script-level globals (const), not window properties.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hv-product', productVariantId: this.variant.id, cartData: data });
        }
        if (cartUI && typeof cartUI.renderContents === 'function' && data.sections) {
          cartUI.classList.remove('is-empty');
          cartUI.renderContents(data);
        } else {
          window.location.href = this.config.cartUrl;
        }
      } catch (err) {
        errorBox.textContent = err.message;
        errorBox.classList.add('is-visible');
      } finally {
        this.atc.classList.remove('is-loading');
        this.atc.removeAttribute('aria-busy');
      }
    }

    /* ---------- Gallery ---------- */
    initGallery() {
      this.track = this.root.querySelector('[data-hv-track]');
      if (!this.track) return;
      this.slides = [...this.track.children];
      const thumbs = [...this.root.querySelectorAll('[data-hv-thumb]')];
      const thumbRow = this.root.querySelector('[data-hv-thumbs]');
      const count = this.root.querySelector('[data-hv-count]');
      const setActive = (i) => {
        if (i === this.activeSlide) return;
        this.activeSlide = i;
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        if (count) count.textContent = i + 1;
        const t = thumbs[i];
        if (t && thumbRow) {
          const left = t.offsetLeft - thumbRow.offsetLeft;
          if (left < thumbRow.scrollLeft || left + t.offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) {
            thumbRow.scrollTo({ left: left - thumbRow.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
          }
        }
      };
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(Math.round(this.track.scrollLeft / this.track.clientWidth));
          ticking = false;
        });
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => this.goToSlide(Number(t.dataset.hvThumb))));
      const prev = this.root.querySelector('[data-hv-prev]');
      const next = this.root.querySelector('[data-hv-next]');
      const last = this.slides.length - 1;
      if (prev) prev.addEventListener('click', () => this.goToSlide(this.activeSlide > 0 ? this.activeSlide - 1 : last));
      if (next) next.addEventListener('click', () => this.goToSlide(this.activeSlide < last ? this.activeSlide + 1 : 0));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' && next) next.click();
        if (e.key === 'ArrowLeft' && prev) prev.click();
      });
      setActive(0);
    }

    goToSlide(i, instant = false) {
      if (!this.track) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
    }

    // Variant changes jump straight to the variant's image instead of sweeping through every slide in between.
    goToMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) this.goToSlide(i, true);
    }

    /* ---------- Sticky bar: visible once the main button has scrolled out of view ---------- */
    initSticky() {
      if (!this.sticky) return;
      const btn = this.sticky.querySelector('[data-hv-sticky-btn]');
      btn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit(this.atc); else this.atc.click();
      });
      const show = (on) => {
        this.sticky.classList.toggle('is-visible', on);
        this.sticky.setAttribute('aria-hidden', String(!on));
        btn.tabIndex = on ? 0 : -1;
        const topBtn = document.querySelector('.scroll-to-top-btn');
        if (topBtn) topBtn.style.marginBottom = on ? `${this.sticky.offsetHeight}px` : '';
      };
      new IntersectionObserver(([entry]) => {
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(this.atc);
    }

    /* ---------- Delivery window: today + N working days (UK weekdays) ---------- */
    initDelivery() {
      const el = this.root.querySelector('[data-hv-delivery]');
      if (!el) return;
      const addWorkingDays = (from, n) => {
        const d = new Date(from);
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) n -= 1;
        }
        return d;
      };
      const min = Number(el.dataset.min) || 7;
      const max = Math.max(min, Number(el.dataset.max) || 12);
      const fmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      const now = new Date();
      el.querySelector('[data-hv-delivery-range]').textContent =
        `${fmt.format(addWorkingDays(now, min))} – ${fmt.format(addWorkingDays(now, max))}`;
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-hv-product-root]').forEach((root) => {
      if (!root.hvProduct) root.hvProduct = new HVProduct(root);
    });
    const reveals = scope.querySelectorAll('.hv-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { reveals.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  };

  // Colourway cards: select the colour in the buy box and bring it into view instead of reloading.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-hv-choose]');
    if (!link) return;
    const root = document.querySelector('[data-hv-product-root]');
    if (!root || !root.hvProduct || !root.hvProduct.selectValue(link.dataset.hvChoose)) return;
    e.preventDefault();
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
